import { defineMessages } from 'react-intl';

export default defineMessages({
    messageLine1: {
        "id": "twia.quoteandbind.wizard.construction.cp.banner.title.lineitem.1.message",
        "defaultMessage": "Seabrook and LaPorte: 1/1/1988 - 3/1/1996",
    },
    messageLine2: {
        "id": "twia.quoteandbind.wizard.construction.cp.banner.title.lineitem.2.message",
        "defaultMessage": "Morgan's Point: 1/1/1988 - 6/1/1996"
    },
    messageLine3: {
        "id": "twia.quoteandbind.wizard.construction.cp.banner.title.lineitem.3.message",
        "defaultMessage": "Pasadena and Shoreacres: 1/1/1988 - 3/1/1997"
    },
    messageLine0: {
        "id": "twia.quoteandbind.wizard.construction.cp.banner.title.message",
        "defaultMessage": "An Official Building Statement is required for the cities and construction dates shown below:"
    },
    yearMustmatch: {
        "id": "quoteandbind.cp.views.construction.The Original Construction Date must be within the Year Built",
        "defaultMessage" : "The Original Construction Date must be within the Year Built."
    },
    cannotBeFutureDate: {
        "id": "quoteandbind.cp.views.construction.Date cannot be in the future.",
        "defaultMessage" : "Date cannot be in the future."
    },
    dateMustmatch: {
        id: "quoteandbind.cp.views.construction.Please enter a valid date (MM/DD/YYYY).",
        defaultMessage : "Please enter a valid date (MM/DD/YYYY)."
    }
})